<template>
  <b-row>
    <b-col cols="12">
      <form-campaign />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormCampaign from './FormCampaign.vue'

export default {
  components: {
    BRow,
    BCol,
    FormCampaign,
  },
}
</script>
